import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a1625d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-description" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: "/img/close-btn.svg",
        class: "modal__close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.title" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.manualTransferInfo.manualTransferDescription" })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "button-text back-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_i18n_t, { keypath: "common.confirm" })
        ]),
        _createElementVNode("button", {
          class: "button-text confirm-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
        }, [
          _createVNode(_component_i18n_t, { keypath: "common.back" })
        ])
      ])
    ])
  ]))
}